/** The route of the Alerts list page (PDW-183 / FE PDW-256), the target of the alert board's "Show all". */
export const ALERT_LIST_ROUTE_PATH: string | null = '/alertList';

/** The alert board's route (PDW-184 / FE PDW-246). */
export const ALERT_BOARD_ROUTE_PATH = '/alertBoard';
